//
// Generated class BankTransferBundleFile
//

/// <reference path="BankTransferBundleFile_ManagedObject.ts" />

class BankTransferBundleFile extends BankTransferBundleFile_ManagedObject
{

}
